const pt = {
    chart: {
        abbr: {
            cr: 'P',
            pr: 'PA',
            pk: 'MP',
            cp: 'R',
            pp: 'RA',
            to: 'T',
            re: 'RE',
            ne: 'NE',
        },
        current_rank: 'Posição Atual',
        previous_rank: 'Posição Anterior',
        current_playcount: 'Reproduções Atuais',
        previous_playcount: 'Reproduções Anteriores',
        peak: 'Melhor Posição',
        debut: 'Estreia',
        chart_points: 'Pontos de Chart',
        total_playcount: 'Total de Reproduções (dentro do chart)',
        rank: 'Posição',
        plays: 'Reproduções',
        playcount: 'Reproduções',
        goto: 'Ver chart',
        update: 'Atualizar Charts',
        update_now: 'NOVA ATUALIZAÇÃO!',
        weekly: 'Charts Semanais',
        total_week: 'Total de semanas no chart',
        re_entry: 'Reentrada',
        new_entry: 'Estreia',
        no_variation: 'Sem variação',
        week_day: 'Dia inicial',
        start_date: 'Data inicial',
        loading: 'Atualizando',
        table: 'Configurações da tabela',
        show_cols: 'Mostrar colunas',
        variation: 'Variação de posições / reproduções',
        table_style: 'Estilo da tabela',
        previous: 'Valor Anterior',
        diff: 'Diferença',
        percent: 'Diferença em porcentagem',
        compact: 'Compacto',
        striped: 'Listrado',
        border: 'Com bordas',
        hover: 'Hover (destacar linha ao selecionar/passar mouse sobre)',
        color: 'Mostrar cores nas variações',
        times: 'Mostrar número de vezes em #1',
        line: 'Borda separando linhas',
        top: 'Top',
        show_dropouts: 'Mostrar saídas do chart',
        dropout: 'Saídas do chart',
        out: 'Saiu',
        untie: 'Alterar posição de empates',
        untie_description: 'Arraste para alterar as posições empatadas no número de reproduções',
    },
    lastfm: {
        username: 'Digite seu nome de usuário no Last.fm',
    },
    messages: {
        first_week: 'Primeira semana pronta!',
        first_week_sub: 'Atenção: Enquanto estiver carregando, a página pode sofrer com lentidão,' +
        ' você já pode navegar pelos seus charts agora, mas recomendamos aguardar até o fim do carregamento.',
        settings_warning: 'Se você alterar estas configurações, seu chart precisará ser carregado novamente.',
        settings_updated: 'Configurações atualizadas com sucesso.',
        images_removed: 'Imagens removidas do cache.',
        remove_images: 'Remover imagens do cache',
        weeks_loaded: 'semanas atualizadas',
        update_complete: 'Atualização completa!',
        update_complete_sub: 'Clique na seta dupla para direita para ver o último chart atualizado.',
        error: 'Oops, ocorreu algum problema.',
        error_connection: 'Tenha certeza que está conectado a internet e tente novamente.',
        limit_warning: 'Um limite alto pode afetar o desempenho do site. Recomendado: entre 20 e 40.',
        zero_warning: 'Coloque 0 para incluir tudo sem limitações.',
        confirm: 'Tem certeza?',
        privacy: 'Política de Privacidade',
        intro: 'Crie seus charts semanais baseado no que você escuta pelo Last.fm',
        read_more: 'Leia mais',
        view_more: 'Ver mais',
        require_update: 'Atualize seus charts',
        untie_complete: 'Chart atualizado!',
        untie_complete_sub: 'A página irá atualizar para que as alterações tenham efeito no seu chart.',
        may_update: 'Att de Maio',
    },
    word: {
        album: 'Álbum | Álbuns',
        artist: 'Artista | Artistas',
        continue: 'Continue',
        forum: 'Fórum',
        image: 'Imagem',
        language: 'Idioma',
        legend: 'Legenda',
        limit: 'Quantidade de músicas',
        update: 'Atualizar',
        updates: 'Atualizações',
        remove: 'Remover',
        save: 'Salvar',
        cancel: 'Cancelar',
        separate: 'Separado',
        settings: 'Configurações',
        timezone: 'Fuso horário',
        title: 'Título',
        title_artist: 'Título, Artista',
        track: 'Música | Músicas',
        user: 'Usuário | Usuários',
        week: 'Semana | Semanas',
        sunday: 'Domingo',
        monday: 'Segunda',
        tuesday: 'Terça',
        wednesday: 'Quarta',
        thursday: 'Quinta',
        friday: 'Sexta',
        saturday: 'Sábado',
        theme: 'Tema',
        action: 'Ação | Ações',
        share: 'Compartilhar',
        new: 'Novo',
        publicity: 'Publicidade',
        year: 'Ano | Anos',
        all_time: 'Todos',
        view_week: 'Ver chart',
    },
    blog: {
        first_stats_update: {
            title: 'Primeira atualização de estatísticas',
            content: 'Its been a long time... <br/>Foram adicionadas as duas primeiras estatíticas do Charts.fm:<br/>A lista de todos os #1s e a lista dos que ficaram mais semanas em #1.<br/>Pretendo trazer mais coisas a partir de agora, pelo menos uma atualização por mês.<br><br>Até mais!',
            date: '2025-04-18',
        },
        dropouts_and_rank_unties: {
            title: 'Edição de músicas empatadas e saídas do chart',
            content: 'Uma das funcionalidades mais pedidas do ZeroCharts agora no Charts.fm:<br/>Edição das posições de músicas/álbuns/artistas empatados. No final da tabela semanal agora há um botão chamado \'Alterar posição de empates\', apertando nele você verá a tela de edição do chart, basta arrastar a músicas emptadas e deixar o chart como quiser. ;)<br/><br/><img src="/img/untie.png" alt="Untie" style="border: 3px solid gray; width: 100%;"><br/><br/>Outra funcionalidade adicionada é a de mostrar as músicas que estavam presentes na semana anterior, e que saíram nessa semana, você pode habilitar ou desabilitar essa opção nas configurações de tabela.<br/><br/><img src="/img/dropout.png" style="border: 3px solid gray; width: 100%" alt="dropout">',
            date: '2025-04-23',
        },
    },
    stats: {
        more: 'Mais estatísticas em breve...',
        number_xs: 'Todos os #{number}s',
        number_ones: {
          title: 'Todos os #1s',
          content: ' Veja a lista completa de artistas, álbuns e músicas que alcançaram o topo (ou posições como #2, #3, etc.) do seu chart semanal.',
        },
        allkill: {
            title: 'Perfect All Kill',
            content: 'Artistas que dominaram a semana, ficando simultaneamente em #1 nos três rankings: artista, álbum e música.',
        },
        most_number_xs: 'Mais semanas em #{number}',
        most_number_ones: {
            title: 'Recordistas de semanas em #1',
            content: 'Conheça quem manteve o primeiro lugar por mais semanas — seja artista, álbum ou música.',
        },
        most_top_xs: 'Mais semanas no top {number}',
        most_weeks: {
            title: 'Presenças mais longas no chart',
            content: ' Explore quem permaneceu mais tempo entre os mais ouvidos do seu ranking semanal.',
        },
        include_only_peak_at: 'Mostrar apenas os que tiveram pico em #{number}',
        most_plays: {
            title: 'Mais reproduzidos',
            content: 'Confira os artistas, álbuns e músicas que tiveram o maior número de execuções em uma única semana.',
        },
        debut: {
            title: 'Estreias de impacto',
            content: 'Veja quais faixas, álbuns e artistas tiveram as semanas de estreia mais fortes nas suas paradas.',
        },
        points: {
            title: 'Acumuladores de pontos',
            content: 'Descubra quem se destacou com consistência e somou mais pontos ao longo do tempo no seu chart.',
        },
        artist_tracks: {
            title: 'Artistas com mais #1s',
            content: 'Encontre os artistas que lideraram com mais músicas e álbuns no topo do seu ranking.',
        },
    },
};

export default pt;
